import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import "./index.css";
import { LayoutSelectorForm } from "./elements/layoutSelector";
import { AuthenticateHeader } from "./elements/authenticateHeader";

export function App() {
  return (
    <div className="min-h-screen relative">
      {/* Fixed Header */}
      <header className="fixed top-0 left-0 w-full bg-white z-50">
        <AuthenticateHeader />
      </header>

      {/* Page Content */}
      <main className="flex flex-col items-center justify-center min-h-screen pt-0 px-6 relative z-10 w-full">
        <Card className="w-full">
          <CardContent className="flex flex-col gap-4">
            <LayoutSelectorForm />
          </CardContent>
        </Card>
      </main>
    </div>
  );
}

export default App;

